import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { open: Boolean }

  connect() {
    if (this.openValue) {
      this.show()
    }
  }

  toggle() {
    if (this.contentTarget.classList.contains('d-none')) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.contentTarget.classList.remove('d-none')
    this.element.classList.add('is-open')
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('fa-chevron-down')
      this.iconTarget.classList.add('fa-chevron-up')
    }
    this.openValue = true
  }

  hide() {
    this.contentTarget.classList.add('d-none')
    this.element.classList.remove('is-open')
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('fa-chevron-up')
      this.iconTarget.classList.add('fa-chevron-down')
    }
    this.openValue = false
  }
}
